const u = window.navigator.userAgent
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端

// 返回
const quit = () => {
  if (isiOS) {
    window.webkit.messageHandlers.js_call_app_quit.postMessage('')
  } else {
    window.jsToAndroid.js_call_app_quit('')
  }
}
// 合并导出
const exportImg = params => {
  if (isiOS) {
    window.webkit.messageHandlers.js_call_app_export_pic.postMessage(params)
    // const result = window.prompt('js_call_app_export_pic')
  } else {
    const stream = JSON.stringify(params)
    const length = stream.length
    const size = 1024 * 100
    const total = Math.ceil(stream.length / size)
    for (let i = 0; i <= total; i++) {
      let params = {
        length,
        size,
        total,
        current: i + 1,
        string: stream.substring(i * size, i * size + size)
      }
      window.jsToAndroid.js_call_app_export_pic(JSON.stringify(params))
    }
  }
}

// 复制
const copyH5Url = (id, type, { copyTemplate }) => {
  const msg = {
    create: '创建电子函成功，链接地址已复制',
    copy: '链接地址已复制'
  }
  let text = window.location.origin + '/#/electronicLetterH5?id=' + id
  if (copyTemplate) {
    text = copyTemplate + ' ' + text
  }
  const params = {
    text,
    msg: msg[type]
  }
  if (isiOS && window.webkit.messageHandlers) {
    window.webkit.messageHandlers.js_call_app_copy.postMessage(params)
  } else {
    if (window.jsToAndroid) {
      window.jsToAndroid.js_call_app_copy(JSON.stringify(params))
    }
  }
}

export { quit, exportImg, copyH5Url }



// WEBPACK FOOTER //
// ./src/utils/h5ToAppHandler.js